import * as ROUTES from './ROUTES';

export const MENU_HOME = {
  icon: 'mdi-home-outline',
  label: ['Home'],
  route: ROUTES.ROUTE_HOME.path,
};

export const MENU_PRODUCAO = {
  icon: 'mdi-cog-clockwise', //gas-station
  label: ['Ordem Produção A'],
  route: ROUTES.ROUTE_PRODUCAO,
};

export const MENU_PRODUCAO_B = {
  icon: 'mdi-cog-clockwise', //gas-station
  label: ['Ordem Produção B'],
  route: ROUTES.ROUTE_PRODUCAO_B,
};

export const MENU_PRODUCAO_C = {
  icon: 'mdi-cog-clockwise', //gas-station
  label: ['Ordem Produção C'],
  route: ROUTES.ROUTE_PRODUCAO_C,
};

export const MENU_PRODUCAO_DUN = {
  icon: 'mdi-cog-clockwise', //gas-station
  label: ['Ordem Produção DUN'],
  route: ROUTES.ROUTE_PRODUCAO_DUN,
};

export const MENU_SECADOR = {
  icon: 'mdi-cog', //gas-station
  label: ['Secador'],
  route: ROUTES.ROUTE_SECADOR,
};

export const MENU_POSICAO_ARMAZEM = {
  icon: 'mdi-package-variant-closed', //gas-station
  label: ['Posição Armazém'],
  route: ROUTES.ROUTE_POSICAO_ARMAZEM,
};

export const MENU_TRANSFERENCIA_PRODUCAO = {
  icon: 'mdi-cog-transfer', //gas-station
  label: ['Transferência Producao'],
  route: ROUTES.ROUTE_TRANSFERENCIA_PRODUCAO,
};

// export const MENU_MONITORAMENTO = {
//   icon: 'mdi-cog-transfer', //gas-station
//   label: ['Monitoramento'],
//   route: ROUTES.ROUTE_MONITORAMENTO,
// };

export const MENU_ORDEM_CARREGAMENTO = {
  icon: 'mdi-truck-cargo-container',
  label: ['Ordem Carregamento'],
  route: ROUTES.ROUTE_ORDEM_CARREGAMENTO,
};

export const MENU_CONTROLE_ARMAZENAMENTO = {
  icon: 'mdi-greenhouse',
  label: ['Controle Armazenamento'],
  route: ROUTES.ROUTE_CONTROLE_ARMAZENAMENTO,
};

export const MENU_PORTARIA_CHECKLIST = {
  icon: 'mdi-truck-outline',
  label: ['Portaria - Checklist'],
  route: ROUTES.ROUTE_PORTARIA_CHECKLIST,
};





// ORDEM DO MENU

export default [
  MENU_HOME,
  MENU_PRODUCAO,
  MENU_PRODUCAO_B,
  MENU_PRODUCAO_C,
  MENU_PRODUCAO_DUN,
  MENU_SECADOR,
  MENU_POSICAO_ARMAZEM,
  // MENU_MONITORAMENTO,
  MENU_TRANSFERENCIA_PRODUCAO,
  MENU_ORDEM_CARREGAMENTO,
  MENU_CONTROLE_ARMAZENAMENTO,
  MENU_PORTARIA_CHECKLIST,
];

export function menuMapper(componentInstance, menus) {
  return [].concat(menus).map((menu) => ({
    ...menu,
    label: String(...menu.label),
  }));
}
